(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var homeTopKey = 'huo-force-home-top-path';

  function forceHomeTopIfRequested() {
    var requestedPath = null;
    try { requestedPath = sessionStorage.getItem(homeTopKey); } catch (e) {}
    if (!requestedPath || window.location.pathname !== requestedPath) return;
    try { sessionStorage.removeItem(homeTopKey); } catch (e) {}
    var reset = function () { window.scrollTo(0, 0); };
    requestAnimationFrame(reset);
    window.setTimeout(reset, 40);
    window.setTimeout(reset, 160);
  }

  document.addEventListener('click', function (event) {
    var logo = event.target.closest && event.target.closest('.header__logo');
    if (!logo || !logo.href) return;
    var target;
    try { target = new URL(logo.href, window.location.href); } catch (e) { return; }
    if (target.origin !== window.location.origin) return;
    if (window.location.pathname === target.pathname) {
      event.preventDefault();
      try { history.replaceState(history.state, '', target.pathname + target.search); } catch (e) {}
      window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      return;
    }
    try { sessionStorage.setItem(homeTopKey, target.pathname); } catch (e) {}
  }, { passive: false });

  window.addEventListener('pageshow', forceHomeTopIfRequested);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', forceHomeTopIfRequested, { once: true });
  else forceHomeTopIfRequested();

  var viewportRaf = 0;
  function syncIntroViewport() {
    viewportRaf = 0;
    var height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    if (!height) return;
    document.querySelectorAll('[data-huo-intro]').forEach(function (intro) {
      intro.style.setProperty('--huo-intro-viewport-height', Math.ceil(height) + 'px');
    });
  }
  function scheduleIntroViewportSync() {
    if (viewportRaf) return;
    viewportRaf = requestAnimationFrame(syncIntroViewport);
  }
  scheduleIntroViewportSync();
  window.addEventListener('resize', scheduleIntroViewportSync, { passive: true });
  window.addEventListener('orientationchange', scheduleIntroViewportSync, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleIntroViewportSync, { passive: true });

  function initReveals(scope) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    scope = scope || document;
    var groups = [
      ['.huo-hero-studio__content', 0],
      ['.five-modes-carousel__header', 0],
      ['.five-modes-carousel__card', 55],
      ['.huo-object-studio__media, .huo-object-studio__copy', 90],
      ['.huo-finishes-stage__header', 0],
      ['.huo-finishes-stage__card', 80],
      ['.huo-how-studio__header', 0],
      ['.huo-how-studio article', 80],
      ['.huo-how-studio__energy > div', 90],
      ['.huo-trust-studio__proofs > div', 65],
      ['.huo-trust-studio__faq > header, .huo-trust-studio__details', 100],
      ['.huo-final-studio__header', 0],
      ['.huo-final-studio__card', 80],
      ['.huo-full-faq header, .huo-full-faq__category, .huo-full-faq__items', 55],
      ['.product-section__medias, .product-section__product-info', 90]
    ];
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-huo-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.07 });
    groups.forEach(function (group) {
      scope.querySelectorAll(group[0]).forEach(function (el, index) {
        if (el.dataset.huoRevealInit === '1') return;
        el.dataset.huoRevealInit = '1';
        el.classList.add('huo-premium-reveal');
        el.style.setProperty('--huo-reveal-delay', Math.min(index * group[1], 180) + 'ms');
        observer.observe(el);
      });
    });
  }

  function initTilt(el) {
    if (!el || el.dataset.huoTiltInit === '1') return;
    el.dataset.huoTiltInit = '1';
    el.classList.add('huo-premium-tilt');
    var raf = 0;
    var latestEvent = null;
    function renderTilt() {
      raf = 0;
      if (!latestEvent) return;
      var rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = (latestEvent.clientX - rect.left) / rect.width - 0.5;
      var y = (latestEvent.clientY - rect.top) / rect.height - 0.5;
      el.style.setProperty('--huo-rx', (-y * 5.5).toFixed(2) + 'deg');
      el.style.setProperty('--huo-ry', (x * 6.5).toFixed(2) + 'deg');
      el.style.setProperty('--huo-tx', (x * 2.2).toFixed(2) + 'px');
      el.style.setProperty('--huo-ty', (y * 2.2).toFixed(2) + 'px');
    }
    el.addEventListener('pointerenter', function () { el.classList.add('is-huo-tilting'); }, { passive: true });
    el.addEventListener('pointermove', function (event) {
      latestEvent = event;
      if (!raf) raf = requestAnimationFrame(renderTilt);
    }, { passive: true });
    el.addEventListener('pointerleave', function () {
      latestEvent = null;
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      el.classList.remove('is-huo-tilting');
      el.style.removeProperty('--huo-rx');
      el.style.removeProperty('--huo-ry');
      el.style.removeProperty('--huo-tx');
      el.style.removeProperty('--huo-ty');
    }, { passive: true });
  }

  function initDesktopDepth(scope) {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)').matches) return;
    scope = scope || document;
    scope.querySelectorAll('.huo-finishes-stage__media, .huo-final-studio__media, .huo-object-studio__media').forEach(initTilt);
  }

  function initHeroParallax(scope) {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)').matches) return;
    scope = scope || document;
    var hero = scope.querySelector('.huo-hero-studio');
    if (!hero || hero.dataset.huoParallaxInit === '1') return;
    hero.dataset.huoParallaxInit = '1';
    var active = true;
    var raf = 0;
    function update() {
      raf = 0;
      if (!active) return;
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var centerOffset = (rect.top + rect.height * 0.5) - vh * 0.5;
      var shift = Math.max(-18, Math.min(18, centerOffset * -0.035));
      hero.style.setProperty('--huo-hero-shift', shift.toFixed(2) + 'px');
    }
    function schedule() {
      if (!active || raf) return;
      raf = requestAnimationFrame(update);
    }
    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        active = !!entries[0].isIntersecting;
        if (active) schedule();
      }, { rootMargin: '15% 0px' });
      visibilityObserver.observe(hero);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }

  function initPremium(scope) {
    initReveals(scope);
    initDesktopDepth(scope);
    initHeroParallax(scope);
    document.documentElement.classList.add('huo-premium-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initPremium(document); }, { once: true });
  else initPremium(document);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initPremium(event.target);
      scheduleIntroViewportSync();
    });
  }
})();
